import React, {useCallback, useEffect, useState} from 'react';
import {Dropdown} from "semantic-ui-react";
import './styles.scss';
import {apiGet} from "../../services/apiClient";
import {getCurrentUserCompanyId} from "../../services/userRights";
import {toast} from "react-toastify";
import throttle from 'lodash.throttle';

const IncomingParcelDropdown = (
    {
        className,
        name,
        value,
        type, // 'senders' или 'locations'
        disabled,
        onChange,
        placeholder,
        searchErrorText,
        error,
        allowAdditions = true
    }
) => {
    const [options, setOptions] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [counter, setCounter] = useState(0);
    const companyId = getCurrentUserCompanyId();

    useEffect(() => {
        if (!options.length) setCounter(counter+1);
        else setCounter(0);
    }, [options]);

    useEffect(() => {
        if (counter === 5 && searchErrorText) {
            toast.error(searchErrorText);
            setCounter(0);
        }
    }, [counter]);

    const searchDataFunc = (text) => {
        if (!companyId) return;

        const url = `incoming-parcels/${type}/${companyId}`;
        const params = text && text.trim() !== '' ? `?searchText=${encodeURIComponent(text)}` : '';

        apiGet(url + params).then(data => {
            const serverItems = (data || []).map((item, index) => ({
                value: item,
                key: item + '_' + index,
                text: item,
                data: { [name]: item }
            }));
            
            // Если есть данные с сервера, используем их
            if (serverItems.length > 0) {
                setOptions(serverItems);
            } else if (text && text.trim() !== '' && allowAdditions) {
                // Если нет данных с сервера, но есть поисковый запрос и разрешены добавления,
                // добавляем только один пункт "Add" для введенного значения
                const addItem = {
                    value: text,
                    key: 'add_' + text,
                    text: `Добавить "${text}"`,
                    data: { [name]: text }
                };
                setOptions([addItem]);
            } else {
                // Если нет ни данных, ни поискового запроса - пустой список
                setOptions([]);
            }
            setCounter(0);
        }).catch((e) => {
            console.log('Ошибка поиска:', e);
            setOptions([]);
        });
    };

    const searchData = useCallback(throttle(searchDataFunc, 600), [companyId, type]);

    const onChangeValue = (e, {value}) => {
        const v = options.find(o => o.value === value);
        if (v && v.data) {
            let values = {};
            values[name] = v.data[name];
            onChange(name, value, values);
        } else {
            // Если это добавленное значение (allowAdditions), передаем его напрямую
            onChange(name, value);
        }
    };

    useEffect(() => {
        setSearchQuery(value || '');
        // Если есть значение, загружаем данные для отображения
        if (value && !options.length) {
            searchData('');
        }
    }, [value]);

    useEffect(() => {
        if (searchQuery && searchQuery !== '') {
            searchData(searchQuery);
        }
    }, [searchQuery]);



    // Загружаем начальные данные при фокусе, если нет поискового запроса
    const handleFocus = () => {
        if (!searchQuery || searchQuery.trim() === '') {
            searchData('');
        }
    };

    return (
        <div style={{ position: 'relative' }}>
            <Dropdown
                error={error}
                className={`selection input-dropdown ${className || ''}`}
                placeholder={placeholder}
                fluid
                selection
                name={name}
                search={() => options}
                searchQuery={searchQuery}
                onSearchChange={(e, {searchQuery}) => {
                    setSearchQuery(searchQuery);
                    // Не очищаем значение при пустом поиске, только при явном удалении
                    if (!searchQuery && value) {
                        onChange(name, null);
                    }
                }}
                onFocus={handleFocus}
                disabled={disabled}
                options={options}
                value={value}
                noResultsMessage={'Не найдено'}
                onChange={onChangeValue}
                selectOnNavigation={false}
                selectOnBlur={false}
                allowAdditions={false} // Используем свою логику добавления
                onBlur={() => {
                    // Восстанавливаем значение только если поисковый запрос пустой
                    if (!searchQuery || searchQuery.trim() === '') {
                        setSearchQuery(value || '');
                    }
                }}
            />
            {/* Собственный крестик */}
            {value && (
                <div
                    style={{
                        position: 'absolute',
                        right: '0.5em',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 1000,
                        cursor: 'pointer',
                        color: '#999',
                        fontSize: '18px',
                        fontWeight: '300',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'transparent',
                        border: 'none',
                        userSelect: 'none'
                    }}
                    onClick={() => {
                        onChange(name, null);
                        setSearchQuery('');
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.color = '#666';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.color = '#999';
                    }}
                >
                    ×
                </div>
            )}
        </div>
    );
};

export default IncomingParcelDropdown; 


// WEBPACK FOOTER //
// ./App/components/Dropdowns/IncomingParcelDropdown.jsx